import React from 'react'
import { Flex, VStack } from '@chakra-ui/react'

import AppointmentInfoSection from './info-section'
import AppointmentClientSection from './client-section'
import AppointmentPatientSection from './patient-section'
import {
    AppointmentDailyHuddleFieldsFragment,
    AppointmentFieldsFragment,
    RescheduleFieldsFragment,
} from '~graphql/generated/graphql'
import AppointmentDetailsHeader from './details-header'
import AppointmentFormsSection from './forms-section'
import AppointmentPaymentsSection from './payment-section'

interface Props {
    appointment:
        | AppointmentDailyHuddleFieldsFragment
        | AppointmentFieldsFragment
    reschedule?: RescheduleFieldsFragment
}

const AppointmentDetails: React.FC<Props> = ({ appointment, reschedule }) => {
    const detailedAppointment =
        'client_forms' in appointment
            ? (appointment as AppointmentFieldsFragment)
            : undefined

    return (
        <VStack w="full" spacing={6} flex={1} px={{ base: 2, md: 0 }}>
            <AppointmentDetailsHeader
                appointment={appointment}
                reschedule={reschedule}
            />
            <Flex
                w="full"
                gridGap={{ base: 4, md: 8 }}
                flexDir={{ base: 'column', md: 'row' }}
            >
                <AppointmentPatientSection appointment={appointment} />
                <AppointmentClientSection appointment={appointment} />
            </Flex>
            {detailedAppointment && (
                <AppointmentFormsSection appointment={detailedAppointment} /> // Should probably just requery here
            )}
            <AppointmentPaymentsSection appointment={appointment} />
            <AppointmentInfoSection
                appointment={appointment}
                reschedule={reschedule}
            />
        </VStack>
    )
}

export default AppointmentDetails
